import { render, staticRenderFns } from "./ImpactMetrics.vue?vue&type=template&id=2409c1ce"
import script from "./ImpactMetrics.vue?vue&type=script&lang=js"
export * from "./ImpactMetrics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports